import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import React from 'react';
import InputFields from 'routes/Pages/components/InputFields/InputFields';
import { useAllUsers } from 'context/AllUserDataContext';
import AdditionalInfoSection from './AdditionalInfoSection';
import { EmployeeNameField, DateTimeField } from './SharedFormFields';

export const ALL_TASK_OPTIONS = [
  'Vehicle Check List',
  'Clock In',
  'Administration',
  'Moisture Content',
  'Clock Out',
  'Chainsaw',
  'Other',
  'Break',
  'Nominate Contact',
  'Cancel',
  'Expense Claim',
  'Repairs & Maintainance',
  'External Repairs',
];

export const GENERAL_TASKS = [
  'Clock In',
  'Administration',
  'Moisture Content',
  'Clock Out',
  'Chainsaw',
  'Other',
  'Break',
  'Nominate Contact',
  'Cancel',
];

const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};

const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': { fontSize: '0.82rem', fontWeight: 500 },
    },
  },
};

const GeneralTaskForm = ({ data, setData, isAdd = false }) => {
  const { allUsers } = useAllUsers();

  const handleChangeData = (name, value) => {
    let updatedData = { [name]: value };
    if (name === 'employeeName') {
      const user = allUsers?.find(item => item.defaultDriverDisplayName === value);
      updatedData['driverUserName'] = user.defaultDriverUserName;
    }
    if (name === 'areYouOvernighting') {
      updatedData['geolocation'] = '';
    }
    setData(prev => ({ ...prev, ...updatedData }));
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': { fontSize: '0.825rem' },
        '& .MuiInputBase-root': { fontSize: '0.825rem !important' },
      }}>
      {/* Shared fields */}
      <EmployeeNameField value={data['employeeName']} onChange={handleChangeData} />
      <DateTimeField value={data['dateAndTime']} onChange={handleChangeData} />

      {/* <InputFields
        label="Task Name"
        name="task"
        required
        value={data['task']}
        textFieldType="text"
        width={4}
        handleIpChange={handleChangeData}
      /> */}

      {/* Clock Out extras */}
      {data.task === 'Clock Out' && (
        <>
          <Grid item xs={6} sm={6} md={4}>
            <InputLabel size="small" sx={dropDownStyles} required>
              Overnight Stay
            </InputLabel>
            <Autocomplete
              size="small"
              disablePortal
              value={data['areYouOvernighting'] || null}
              options={['Yes', 'No']}
              onChange={(_, newValue) => handleChangeData('areYouOvernighting', newValue)}
              renderInput={params => <TextField required {...params} size="small" fullWidth />}
              fullWidth
              slotProps={{ ...autoCompleteSlotProps }}
            />
          </Grid>
          {data['areYouOvernighting'] === 'Yes' && (
            <InputFields
              label="Full Name (Accommodation)"
              name="geolocation"
              required={data['areYouOvernighting'] === 'Yes'}
              value={data['geolocation']}
              textFieldType="text"
              multiline
              width={8}
              handleIpChange={handleChangeData}
              disabled={data['areYouOvernighting'] !== 'Yes'}
            />
          )}

          <Grid item xs={12} sm={12} md={12} mt={2}>
            <FormControl>
              <FormLabel>Were you working more than 10 km away from office/home?</FormLabel>
              <RadioGroup
                name="workingMoreThan10kmAway"
                row
                value={data['workingMoreThan10kmAway'] || null}
                onChange={(_, newValue) => handleChangeData('workingMoreThan10kmAway', newValue)}>
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel value="Less than 5 hrs" control={<Radio />} label="Less than 5 hrs" />
                <FormControlLabel value="5 - 10 hrs" control={<Radio />} label="5 - 10 hrs" />
                <FormControlLabel value="More than 10 hrs" control={<Radio />} label="More than 10 hrs" />
              </RadioGroup>
            </FormControl>
          </Grid>
        </>
      )}

      {/* Break extra */}
      {data.task === 'Break' && (
        <InputFields
          label="Duration"
          name="duration"
          required
          value={data['duration']}
          textFieldType="time"
          width={4}
          handleIpChange={handleChangeData}
        />
      )}

      {/* Holiday extra */}
      {data.task === 'Holiday' && (
        <InputFields
          label="Number of days Holidays requested"
          name="numberOfHolidaysRequested"
          required
          value={data['numberOfHolidaysRequested']}
          textFieldType="number"
          width={4}
          handleIpChange={handleChangeData}
        />
      )}

      {/* Nominate Contact extra */}
      {data.task === 'Nominate Contact' && (
        <Grid item xs={6} sm={6} md={4}>
          <InputLabel size="small" sx={dropDownStyles} required>
            Check Name
          </InputLabel>
          <Autocomplete
            size="small"
            disablePortal
            value={allUsers.find(u => u.email === data['nominatedName']) || null}
            options={allUsers}
            onChange={(_, newValue) => handleChangeData('nominatedName', newValue?.email || '')}
            getOptionLabel={option => option.email || ''}
            isOptionEqualToValue={option => option.email === data['nominatedName']}
            renderInput={params => <TextField required {...params} size="small" fullWidth />}
            fullWidth
            slotProps={{ ...autoCompleteSlotProps }}
          />
        </Grid>
      )}

      <AdditionalInfoSection data={data} handleChange={handleChangeData} />
    </Grid>
  );
};

export default GeneralTaskForm;
